<template>
    <modal-component id="timeout-modal" :visible="timeoutModal" @close="resetTimeoutModal()">
        <div>
            <p class="text-center">You have been inactive for {{ this.timeout }} minutes.</p>
            <p class="text-center">
                You will be automatically logged out soon for security purposes
            </p>
            <p class="text-center">You will be logged out in:</p>
            <p class="text-center">
                <span class="text-danger" style="font-size: 1.5em;">{{ this.timeToLogout }}</span>
                seconds
            </p>
            <div class="d-flex flex-column w-100 justify-content-between align-items-center py-3">
                <button
                    id="archive-client"
                    class="btn btn-sm btn-primary font-weight-bold text-uppercase text-white"
                    @click="resetTimeoutModal()"
                >
                    <span>I'm still here!</span>
                </button>
            </div>
        </div>
    </modal-component>
</template>

<script>
import ModalComponent from "./ui/ModalComponent";

export default {
    name: "TimeoutDialog",
    props: ["timeout"],
    components: {
        ModalComponent,
    },
    data() {
        return {
            exclusions: ["/data-tracker"],
            timeoutModal: false,
            timer: setInterval(() => {
                if (this.timeoutModal === true) {
                    if (this.timeToLogout === 0) {
                        this.signout();
                    } else {
                        this.timeToLogout = this.timeToLogout - 1;
                    }
                }
            }, 1000),
            timeToLogout: 31,
            pinger: undefined,
        };
    },
    onIdle() {
        if (!this.toIgnore) {
            this.timeoutModal = true;
        }
    },
    mounted() {
        if (this.pinger) return;
        this.pinger = setInterval(this.resetTimeoutModal, 2 * this.$timeout);
    },
    computed: {
        toIgnore: function() {
            return this.exclusions.some(value => {
                const regex = new RegExp(value);
                const path = document.location.pathname;
                return regex.test(path);
            });
        },
    },
    destroy() {
        this.pinger.clearInterval();
    },
    methods: {
        signout() {
            axios
                .post("/autologout")
                .then(() => {
                    window.location.replace("/login");
                })
                .catch(e => {
                    console.error(e);
                    window.location.replace("/login");
                });
        },
        resetTimeout() {
            window.dispatchEvent(new Event("mousemove"));
            this.timeoutModal = false;
            this.timeToLogout = 31;
        },
        resetTimeoutModal() {
            axios
                .get("/ping")
                .then(response => {
                    if (response.data === "These aren't the droids you are looking for") {
                        this.resetTimeout();
                    } else {
                        window.location.replace("/login");
                    }
                })
                .catch(e => {
                    window.location.replace("/login");
                });
        },
    },
};
</script>
